/** General-purpose string helpers, each safe to call with a value of any type. */

/**
 * Removes every run of non-word characters, leaving letters, digits and underscores.
 *
 * Case is untouched, so `12/2 Romex` becomes `122Romex`. `\W` is ASCII-only, so an accented or
 * non-Latin term reduces to whatever is left of it.
 *
 * @param {*} value - Value to reduce to its word characters.
 * @returns {string} `value` stripped, or `''` when it is not a string.
 */
export const stripNonWordCharacters = (value) => (
  typeof value === 'string' ? value.replace(/\W+/g, '') : ''
);
